import { Button, InputElement } from "common/components/StyledElements";
import { message } from "antd";
import APIConstants from "common/constants/APIConstants";
import { useMutation } from "react-query";
import { api } from "common/utils/APIMethods";
import { useAuthContext } from "common/contexts/AuthContext";
import styled from "styled-components";
import { useState } from "react";

const Container = styled.div`
  margin-left: 20px;
`;

const HorizontalContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const ButtonContainer = styled.div`
  max-width: 350px;
  display: flex;
  justify-content: space-around;
`;
const ButtonsSelfContainer = styled.div`
  margin-right: auto;
`;
const FieldContainer = styled.div`
  margin-right: 40px;
  height: 100px;
  width: 250px;
`;

const DistributorRefresh = () => {
  const [distributorId, setDistributorId] = useState("");
  const { authConfig } = useAuthContext();
  const { refreshDB } = APIConstants;
  const { isLoading, mutate } = useMutation(
    (supplierId) =>
      api(
        {
          url: `${refreshDB}/${supplierId}`,
          method: "PUT"
        },
        authConfig
      ),
    {
      onSuccess: (response) => {
        message.success(response);
        setDistributorId("");
      },
      onError: (err) => {
        message.error(
          err?.message || "There was some error, Please try again."
        );
      }
    }
  );

  return (
    <Container key="Container">
      <HorizontalContainer>
        <FieldContainer>
          <InputElement
            onChange={(distributorData) => {
              setDistributorId(distributorData?.target?.value);
            }}
            allowClear
            value={distributorId}
            type="phone"
            maxLength={10}
            placeholder="Enter Distributor Id"
          />
        </FieldContainer>
        <FieldContainer>
          <ButtonContainer>
            <ButtonsSelfContainer>
              <Button
                primary="true"
                onClick={() => mutate(distributorId)}
                loading={isLoading}
                disabled={!distributorId}
              >
                Refresh DB
              </Button>
            </ButtonsSelfContainer>
          </ButtonContainer>
        </FieldContainer>
      </HorizontalContainer>
      <p>
        * Refresh DB deletes the ledgers , inventory, cart , outstanding history
        and invoices of the selected distributor.
      </p>
    </Container>
  );
};

export default DistributorRefresh;
